import dayjs from 'dayjs'
import conversionUtcDate from 'src/utils/conversionUtcDate'
import { getAllDashboard } from '/src/@api/dashboard'
import { generateMockData } from 'src/utils'
import { getUserAccountOrder } from 'src/@api/login'
import { createDeviceScopedChatSlice } from 'src/store/apps/createDeviceScopedChatSlice'

const readDeviceSnapshot = () => ({
  deviceUser: JSON.parse(localStorage.getItem('DeviceUser') || '{}'),
  currentDevice: JSON.parse(localStorage.getItem('currentDevice') || '{}')
})

const loadSummary = async ({ page }) => {
  const { deviceUser, currentDevice } = readDeviceSnapshot()
  const username = deviceUser?.username || ''
  const deviceUdid = currentDevice?.['Unique Identifier'] || ''
  const orders = await getUserAccountOrder({ page: 1, pageSize: 10 })
  const lastOrder = orders.data.sort((a, b) => dayjs(b.expire_time).valueOf() - dayjs(a.expire_time).valueOf())[0]
  const response = await getAllDashboard({
    username,
    params: { category: 'WHATSAPP_SMB_SUMMARY', offset: (page - 1) * 50, limit: 50, deviceUdid }
  })
  let data = response.data.contents?.map(item => ({
    ...item,
    time: conversionUtcDate(item.snippetTimestamp, 'local', 'YYYY-MM-DD'),
    defaultAvata: '/images/avatars/10.png'
  })) || []
  const advanced = username == null || !('advanced' in response) || [true, 'true'].includes(response?.advanced)
  if (!advanced) {
    data = generateMockData(data).map((item, index) => index === 0 ? item : { ...item, PK: `${index}spyx` })
  }

  let defaultSelectData = []
  if (page === 1 && data[0]) {
    const detail = await getAllDashboard({
      username,
      params: { category: 'WHATSAPP_SMB_DETAIL', offset: 0, limit: 50, deviceUdid, rid: String(data[0].PK) }
    })
    defaultSelectData = detail.data.contents?.map(item => ({
      ...item,
      time: conversionUtcDate(item.date, 'local', 'YYYY-MM-DD HH:mm'),
      defaultAvata: '/images/avatars/10.png'
    })) || []
  }

  return {
    data,
    defaultSelectData,
    leftTotalCount: response.data.totalCount,
    advanced,
    replaceList: !advanced,
    nextLeftPage: advanced ? page : 0
  }
}

const loadDetail = async ({ contact, page }) => {
  const { deviceUser, currentDevice } = readDeviceSnapshot()
  const response = await getAllDashboard({
    username: deviceUser?.username || '',
    params: {
      category: 'WHATSAPP_SMB_DETAIL',
      offset: (page - 1) * 50,
      limit: 50,
      deviceUdid: currentDevice?.['Unique Identifier'] || '',
      rid: String(contact.PK)
    }
  })
  const selected = response.data.contents?.map(item => ({
    ...item,
    time: conversionUtcDate(item.date, 'local', 'YYYY-MM-DD HH:mm'),
    defaultAvata: '/images/avatars/10.png'
  })) || []

  return { selected, rightTotalCount: response.data.totalCount }
}

const chat = createDeviceScopedChatSlice({
  sliceName: 'WaBusiness',
  storeKey: 'WaBusiness',
  actionPrefix: 'waBusiness',
  contactKey: 'PK',
  storageKey: 'waBusinessItem',
  loadSummary,
  loadDetail,
  createExtraState: () => ({
    preViewImage: { open: false, url: '' },
    advanced: true,
  }),
  applySummary: (state, payload) => {
    state.advanced = [true, 'true'].includes(payload.advanced)
  }
})

export const fetchUserProfile = chat.fetchSummary
export const selectMessage = chat.selectDetail
export const setPerViewImage = chat.setPerViewImage
export const removeSelectedChat = chat.removeSelectedChat
export default chat.reducer
